export interface ResponseGetMerchflowStorePog_storePogId_logs {
  id: number;
  pm_data_path: string | null;
  ff_data_path: string | null;
  pogger_request_path: string | null;
  pogger_response_path: string | null;
  update_request_path: string | null;
  update_response_path: string | null;
}

export const RouteGetMerchflowStorePog_storePogId_logs = "/merchflow/store/pog/:storePogId/logs";
